import { memo } from "react";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";

interface TaskCreatorAndEditorSheetFooterProps {
  onClick: () => void;
  text: string;
  isLoading: boolean;
  isDisabled: boolean;
  testId?: string;
}

export const TaskCreatorAndEditorSheetFooter = memo(
  (props: TaskCreatorAndEditorSheetFooterProps) => {
    const { onClick, text, isLoading, isDisabled, testId } = props;

    return (
      <FixaModalFooter>
        <FixaButton
          data-testid={testId}
          onClick={onClick}
          text={text}
          fluid
          type="primary"
          loading={isLoading}
          disabled={isDisabled}
          htmlType="button"
        />
      </FixaModalFooter>
    );
  }
);
